/** Parasmaipad + ātmanepad kartari-style rūpa fields (full). */
export const TINGANTA_RUP_KARTARI_FIELD_KEYS = [
  'plat',
  'plit',
  'plut',
  'plrut',
  'plot',
  'plang',
  'pvidhiling',
  'pashirling',
  'plung',
  'plrung',
  'alat',
  'alit',
  'alut',
  'alrut',
  'alot',
  'alang',
  'avidhiling',
  'aashirling',
  'alung',
  'alrung',
] as const;

/** Karmani / ātmanepad-only blocks (10 fields). */
export const TINGANTA_RUP_KARMANI_FIELD_KEYS = [
  'alat',
  'alit',
  'alut',
  'alrut',
  'alot',
  'alang',
  'avidhiling',
  'aashirling',
  'alung',
  'alrung',
] as const;

/** Parasmaipad-only (e.g. yaṅluk kartari). */
export const TINGANTA_RUP_PARASMAI_FIELD_KEYS = [
  'plat',
  'plit',
  'plut',
  'plrut',
  'plot',
  'plang',
  'pvidhiling',
  'pashirling',
  'plung',
  'plrung',
] as const;

export type TingantaRupKartariFieldKey = (typeof TINGANTA_RUP_KARTARI_FIELD_KEYS)[number];
export type TingantaRupKarmaniFieldKey = (typeof TINGANTA_RUP_KARMANI_FIELD_KEYS)[number];
export type TingantaRupParasmaiFieldKey = (typeof TINGANTA_RUP_PARASMAI_FIELD_KEYS)[number];
